import CityManagementPage from "./shared/CityManagementPage";
import { allCityConfigs } from "./shared/cityConfigExtended";

export default function Dubai() {
  return <CityManagementPage config={allCityConfigs.dubai} />;
}